'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Marathi Lingayat Matrimony" },
  { label: "Marathi Lingayat Caste" },
  { label: "Veershaiv Lingayat matrimony" },
  { label: "Veershaiv Bhavan Wadgaon Sheri" },
  { label: "Veershaiv Lingayat Vadhu Var" },
  { label: "Veershaiv Mangal Karyalay Baramati" },
  { label: "Veershaiv Lingayat Vadhu Var Suchak" },
  { label: "Veershaiv Lingayat caste" },
  { label: "Veershaiv Lingayat matrimony Belgaum" },
  { label: "Veershaiv Mangal Karyalay Latur" },
  { label: "Veershaiv Bhavan Vadgaon Sheri" },
  { label: "Veershaiv Kakkaya Dhor Samaj" },
  { label: "Veerashaiva Lingayat matrimony" },
  { label: "Lingayat matrimony login" },
  { label: "Lingayat matrimony WhatsApp group" },
  { label: "Lingayat matrimony photos girl" },
  { label: "Lingayat matrimony photos" },
  { label: "Divorced Lingayat matrimony" },
  { label: "Lingayat matrimony brides" },
  { label: "Lingayat matrimony photos boy" },
  { label: "Veerashaiva Lingayat matrimony grooms" },
  { label: "Brides Veerashaiva Lingayat matrimony" },
  { label: "Lingayat matrimony Pune" },
  { label: "Veershaiv-Lingayat Bhavan Photos" },
  { label: "Veershaiv Lingayat matrimony Pune" },
  { label: "Veershaiv Vadhu Var Suchak Kendra Photos" },
  { label: "Veershaiv Vadhu Var Suchak Kendra reviews" },
  { label: "Veershaiv Vadhu Var Suchak Kendra Pune" },
  { label: "Veershaiv Vadhu Var Suchak Kendra" },
];

export default function LingayatMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी लिंगायत समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="lingayat_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How to search the Marathi Lingayat matrimony girl online?",
                  answer: "First register free through MarathiVadhuVarSuchak.com Marathi matrimony site. After approval you can search Marathi Lingayat girl profiles online."
                },
                {
                  question: "How to search the Marathi Lingayat matrimony grooms?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony site for free registration. After profile approval you can you can search Marathi Lingayat grooms online."
                },
                {
                  question: "Which is the best Veerashaiva Marathi Lingayat matrimony?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimonial site is the most trusted brand for Marathi Veerashaiva Lingayat Samaj Vadhu Var."
                },
                {
                  question: "Which is the best Lingayat Vadhu Var Suchak Pune?",
                  answer: "For Marathi Lingayat Vadhu Var from Pune could register free through MarathiVadhuVarSuchak.com Marathi matrimony site."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Lingayat Matrimony for Veershaiv Lingayat Communities"
        items={communityServices}
      />

    </div>
  );
}
